export const Logo = ({ className = "h-12" }) => (
  <img src="/brand/logo-sm.webp" alt="iBookStudio" className={`w-auto select-none ${className}`} draggable={false} data-testid="brand-logo" />
);

export const LogoIcon = ({ className = "h-6" }) => (
  <img src="/brand/icon-192.png" alt="iBookStudio" className={`w-auto select-none ${className}`} draggable={false} data-testid="brand-icon" />
);

export const DevCredit = ({ className = "" }) => (
  <p className={`text-center text-[11px] text-[#64748B] ${className}`} data-testid="dev-credit">
    Developed by <span className="font-semibold text-[#3D3DF0]">Geneza Solutions Pvt Ltd</span>
  </p>
);
